<template>
  <div id="app" class="">
    <div class="container-fluid wrapper  ">
      <div class="row">
        <div class="col-4">
          <div class="row">
            <div class="col">
              <div id="pc-logo-block">
                <img src="/img/logo.png"></div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <Processed
                  id="process-block"
                  :inActiveText="getBatch ? null :  'Geen batch actief'"
                  :inActiveClass="'inactive'"
                  :current-value="getTotalFromBatch.total"
                  :total-value="getBatch ? parseInt(getBatch.batchSize) : 0 "
                  :wrapper-class="'processed-counter-block'"
                  :counter-class="'counter'"
              ></Processed>
            </div>

          </div>
          <div class="row">
            <div class="col" style="padding-right:7.5px">
              <NormGauge
                  :gaugeData="getWeekPercentage.dataset"
                  :title="'Wekelijks'"
                  :currentValue="getWeekPercentage.value"
                  :innerGaugeValueIndicator="'Yield'"
                  :innerGaugeValueType="'%'"
                  :subGaugeText="''"
                  :wrapper-class="'weekly-counter-block'"
                  :gauge-class-success-color="'weekly-gauge'"
              >
              </NormGauge>
            </div>
            <div class="col" style="padding-left:7.5px">
              <NormGauge
                  :gaugeData="getMonthPercentage.dataset"
                  :currentValue="getMonthPercentage.value"
                  :innerGaugeValueIndicator="'Yield'"
                  :innerGaugeValueType="'%'"
                  :title="'Maandelijks'"
                  :subGaugeText="''"
                  :wrapper-class="'monthly-counter-block'"
              >
              </NormGauge>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <TopDefects id="top-defects-table" :defects="getTopDefects"></TopDefects>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-12 ">
              <div id="waste-gauge-block" :class="'waste-gauge '+ wageGaugeClass">
                <div class="inactive" v-show="!getBatch" style="z-index:300"></div>
                <h3>Yield percentage </h3>

                <div class="circleBase type1" style="z-index: 0 "></div>
                <waste-gauge @normStatusClass="wasteGaugeBackgroundClass($event)"
                             style="z-index: 3"></waste-gauge>
                <p class="waste-percentage" style="z-index: 3 ">
                  {{ parseInt(getTotalFromBatch.percentage).toFixed(0) }} %</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">

              <div id="heartbeat" v-show="showHeartbeat">

                <div class="inactive" v-show="!getBatch"></div>
                <h3>Defects progress </h3>
                <StackedHeartBeat v-if="getBatch" id="heartbeatchart"
                                  :chartData=heartBeatData()></StackedHeartBeat>
              </div>
              <div id="currentDefects" v-show="!showHeartbeat" v-if="getBatch && getApiDefects">
                <div class="inactive" v-show="!getBatch"></div>
                <h3>Current defects </h3>
                <ul>
                  <li>
                    <p style="background:#5ab82e;">Goed</p> <span> {{ getBatch.approved }}</span>
                  </li>
                  <li style="background:#17a2b8">
                    <p>Nabewerken</p> <span>{{ getBatch.redo }}</span>
                  </li>
                  <li>
                    <p style="background:#5b5b5b;">Materiaal afwijking</p> <span>{{ getMateriaalAfwijking }}</span>
                  </li>
                  <li v-for="(defect, index) in getCurrentDefects" v-if="index <= 2">
                    <p>{{ defect.name }}</p> <span>{{ defect.value }}</span>
                  </li>
                </ul>
                <ul>
                  <li v-for="(defect, index) in getCurrentDefects" v-if="index > 2">
                    <p>{{ defect.name }}</p> <span>{{ defect.value }}</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <check-connection></check-connection>

  </div>
</template>


<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'
import checkConnection from './components/checkConnection'
import Processed from './components/Processed'
import NormGauge from './components/NormGauge'
import WasteGauge from './components/WasteGauge'
import TopDefects from './components/TopDefects'


import StackedHeartBeat from './components/StackedHeartBeat'

export default {
  components: {
    checkConnection,
    Processed,
    NormGauge,
    WasteGauge,
    TopDefects,
    StackedHeartBeat
  },
  data() {
    return {
      activeBatch: [],
      showHeartbeat: false,
      wageGaugeClass: 'status-green'
    }
  },
  firestore() {
    return {
      activeBatch: this.$FB.collection('batches').where("active", "==", true).limit(1)
    }
  },
  methods: {
    ...mapActions(['getScreenData']),
    heartBeatData() {
      var data = {labels: this.getHeartBeatData.labels, datasets: this.getHeartBeatData.datasets}
      return data
    },
    wasteGaugeBackgroundClass(event) {
      this.wageGaugeClass = event
    }
  },
  computed: {
    ...mapGetters([
      'getBatch',
      'getTotalFromBatch',
      'getWeekPercentage',
      'getMonthPercentage',
      'getTopDefects',
      'getNormValue',
      'getHeartBeatData',
      'getApiDefects',
    ]),
    getMateriaalAfwijking() {
       let afwijking = _.find(this.getBatch.defects, def => {
         return def.defect_id === 16

      })
       return afwijking ? afwijking.value : 0
    },
    getCurrentDefects() {
      let self = this;
      let defects = this.getBatch.defects;

      let defectsWithValue = _.remove(defects, function (o) {

        return o.value && o.defect_id !== 16
      });

      _.forEach(defectsWithValue, function (defects) {
        defects.name = _.find(self.getApiDefects, function (o) {
          return o.id === defects.defect_id
        }).name
      });

      return _.orderBy(defectsWithValue, ['value'], ['desc']);
    },
  },
  watch: {
    activeBatch(newV) {
      if (newV.length) {
        this.$store.commit('setBatch', newV)
        this.$store.dispatch('updateDefects')
      } else {
        // this.$store.dispatch('updateDefects')
        DATA_API
            .get('/dashboard/defects')
            .then(response => {
              this.$store.commit('setDefects', response.data);
            })
        this.$store.commit('setBatch', null)
      }
    }
  }
  ,
  created() {
    DATA_API
        .get('/dashboard/defects')
        .then(response => {
          this.$store.commit('setDefects', response.data);
        })
    this.getScreenData()
    setInterval(() => {
      this.getScreenData()
    }, 5 * 3600)

    setInterval(() => {
      this.showHeartbeat = !this.showHeartbeat;
    }, 30000)
  },
}
</script>

<style lang="scss">
html {
  border: none;
}

@import 'assets/scss/main.scss';
@import 'assets/scss/processed';
@import 'assets/scss/ftr_gauges';
@import 'assets/scss/waste_gauge';
</style>
